import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import CopyTextButton from '@/components/CopyTextButton'
import KeyValue from '@/components/KeyValue'

import messages from './messages'

const SensitiveWrapper = styled.div`
  background-color: #f1fae9;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: inline-block;

  .keyvalues__label {
    font-size: 14px;
  }

  .keyvalues__value {
    font-size: 14px;
    display: inline-block;
    word-break: break-word;
    width: 90%;
  }

  .copy-to-clipboard {
    vertical-align: 100%;
  }
`

const WebHookDisplay = ({ webHookUrl, className }: any) => {
  const workgridWebHookUrl = webHookUrl || ''
  const publicWebHookUrl = workgridWebHookUrl.replace('/workgrid/', '/public/')

  return (
    <SensitiveWrapper className={className}>
      <div className="read-only-label">
        <KeyValue>
          <KeyValue.Label>
            <FormattedMessage {...messages.webHookUrl} />
          </KeyValue.Label>
          <div>
            <KeyValue.Value>
              <span>{publicWebHookUrl}</span>
            </KeyValue.Value>
            <CopyTextButton text={publicWebHookUrl} />
          </div>
        </KeyValue>
      </div>
    </SensitiveWrapper>
  )
}

WebHookDisplay.displayName = 'WebHookDisplay'

WebHookDisplay.propTypes = {
  webHookUrl: PropTypes.string,
  className: PropTypes.string
}

export default WebHookDisplay
